type MimeType = string;
type FileExtension = string;

type SupportedFormats = Record<MimeType, FileExtension[]>;

const SUPPORTED_DOCUMENT_FORMATS = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  /**
  These legacy formats are not widely supported by third parties (e.g. LLM providers)
  and are easliy converted by the user. We've opted against accepting them for now.
   "application/vnd.ms-powerpoint": [".ppt"],
   "application/msword": [".doc"],
   "application/vnd.ms-excel": [".xls"],
   **/
} as const satisfies SupportedFormats;

const SUPPORTED_IMAGE_FORMATS = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
} as const satisfies SupportedFormats;

const SUPPORTED_VIDEO_FORMATS = {
  // For now - only support mp4. We might want to support other file types /
  // transcode in the future.
  "video/mp4": [".mp4"],
} as const satisfies SupportedFormats;

export const SUPPORTED_VT_LIBRARY_FORMATS = {...SUPPORTED_DOCUMENT_FORMATS, ...SUPPORTED_IMAGE_FORMATS};

/** File formats allowed to be uploaded directly to the data room or via the audit portal. */
export const SUPPORTED_TPRM_SOURCE_FORMATS = {
  ...SUPPORTED_DOCUMENT_FORMATS,
  ...SUPPORTED_IMAGE_FORMATS,
  ...SUPPORTED_VIDEO_FORMATS,
  "text/csv": [".csv"],
};

export const formatFileSize = (bytes: number, decimalPoint?: number) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1000;
  const dm = decimalPoint || 2;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};
